/**
 * Fügt den Wert entweder an oder ersetzt einen Wert bei vorhandenem Index >= 0. Der Index wird im Anschluss gelöscht
 * @param array
 * @param value
 */
export function storeIndexedValue(array, value) {
    const index = value.index;
    delete value.index;
    if (index >= 0) {
        array[index] = { ...array[index], ...value };
    } else {
        array.push(value);
    }
}

/**
 * Löscht den Wert mit enthaltenem Index aus dem Array
 * @param array
 * @param value
 */
export function deleteIndexedValue(array, value) {
    array.splice(value.index, 1);
}
